export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCudd8P2B99iKy0TEtMue_geGhlPxJnS_o",
    authDomain: "mac-76b25.firebaseapp.com",
    projectId: "mac-76b25",
    storageBucket: "mac-76b25.appspot.com",
    messagingSenderId: "952183670507",
    appId: "1:952183670507:web:ad8cccd8fe6b85bfbaa0ae"
  }
};
